import {
	DATASET,
	INITIATIVE,
	SCORECARD_ITEM
} from 'scoreboard/components/domain-type'
import unwrapModel from 'scoreboard/components/unwrap-model'
import fieldAggregationDescription from 'scoreboard/datasets/field-aggregation-description'

/**
 * Returns the default label (sometimes called Title or Name) based on a
 * widget's data source
 *
 * @param {DataSourceWidgetModel} model
 * @return {String}
 */
function defaultDataSourceLabel (model) {
	let domainType = model.domainType()

	if (domainType === DATASET) {
		return defaultDatasetSourceLabel(model.dataset(), model.properties)
	} else if (domainType === SCORECARD_ITEM || domainType === INITIATIVE) {
		return model.domainObject()?.label
	}
}

/**
 * Returns the default label (sometimes called Title or Name) based on a
 * dataset widget's source
 *
 * @param {Dataset} dataset
 * @param {Backbone.Model|Object} widgetProps - the widget's properties. This
 * can be the model.properties Model or a plain object (useful when the widget
 * hasn't been created yet)
 *
 * @return {String}
 */
function defaultDatasetSourceLabel (dataset, widgetProps) {
	if (!dataset) {
		return null
	}

	widgetProps = unwrapModel(widgetProps)

	let aggregationField = dataset.combinedFieldsById[widgetProps.fieldId]
	let aggregationVisibleLinkedField = dataset.visibleLinkedFieldsById[
		widgetProps.visibleLinkedFieldId]
	let aggregationType = widgetProps.aggregationType

	return fieldAggregationDescription({
		dataset,
		aggregationField,
		aggregationVisibleLinkedField,
		aggregationType,
		equation: widgetProps.equation,
		tracked: dataset.get('tracked')
	})
}

export default defaultDataSourceLabel
export { defaultDatasetSourceLabel }

defaultDataSourceLabel.__filename__ = 'dashboards/widgets/default-data-source-label.js'
